import React, { useEffect, useRef } from 'react';
import Button from '../atoms/Button';
import { setIsEdit } from '../../redux/appDetails/reducer';
import { useSelector , useDispatch} from 'react-redux';  

/**
 * Horizontal stepper organism.
 * Reflects URL-driven step (1-indexed).
 */
export default function Stepper({
  steps = [],
  currentStep = 1,
  onStepClick,
  className = '',
  size = 'md',
  showSaveButton = false,
  showNextButton = false,
  onSaveDraft,
  onNext,
  saveLabel = 'Save Draft',
  nextLabel = 'Next >',
  extraActions = null,
}) {
  const itemRefs = useRef({});
  const dispatch = useDispatch();
  const { isEdit } = useSelector((state) => state.appDetails || {});

  useEffect(() => {
    const item = itemRefs.current[currentStep];
    if (!item) return;

    const frame = requestAnimationFrame(() => {
      let scroller = item.parentElement;
      while (scroller && scroller !== document.body) {
        const { overflowX } = getComputedStyle(scroller);
        const scrollsX = scroller.scrollWidth > scroller.clientWidth + 1;
        if (scrollsX && (overflowX === 'auto' || overflowX === 'scroll')) break;
        scroller = scroller.parentElement;
      }
      if (!scroller || scroller === document.body) return;

      const scrollerRect = scroller.getBoundingClientRect();
      const itemRect = item.getBoundingClientRect();
      const pad = 12;
      const fullyVisible =
        itemRect.left >= scrollerRect.left + pad &&
        itemRect.right <= scrollerRect.right - pad;
      if (fullyVisible) return;

      const delta =
        itemRect.left -
        scrollerRect.left -
        (scrollerRect.width - itemRect.width) / 2;
      scroller.scrollTo({
        left: scroller.scrollLeft + delta,
        behavior: 'smooth',
      });
    });

    return () => cancelAnimationFrame(frame);
  }, [currentStep]);

  return (
    <div className={`ca-stepper-wrap ca-stepper-wrap--${size} ${className}`.trim()}>
      <nav className={`ca-stepper ca-stepper--${size}`} aria-label="Progress">
        {steps.map((step, index) => {
          const stepId = step.id ?? index + 1;
          const isActive = stepId === currentStep;
          const isDone = stepId < currentStep;
          const clickable = Boolean(onStepClick) && (isDone || isActive);

          return (
            <button
              key={stepId}
              type="button"
              ref={(node) => {
                itemRefs.current[stepId] = node;
              }}
              className={[
                'ca-stepper__item',
                isActive ? 'ca-stepper__item--active' : '',
                isDone ? 'ca-stepper__item--done' : '',
              ]
                .filter(Boolean)
                .join(' ')}
              style={{ zIndex: steps.length - index }}
              onClick={() => {
                console.log('setting is edit is true');
                // setIsEdit({ data: true });
                dispatch(setIsEdit({ data: true }));
                console.log(isEdit);
                clickable && onStepClick?.(stepId);
              }}
              disabled={!clickable}
              aria-current={isActive ? 'step' : undefined}
            >
              <span className="ca-stepper__circle">{stepId}.</span>
              <span className="ca-stepper__label">{step.label}</span>
            </button>
          );
        })}
      </nav>
      {showSaveButton || showNextButton || extraActions ? (
        <div className="ca-stepper__actions">
          {extraActions}
          {showSaveButton ? (
            <Button variant="outline" onClick={onSaveDraft}>{saveLabel}</Button>
          ) : null}
          {showNextButton ? <Button onClick={onNext}>{nextLabel}</Button> : null}
        </div>
      ) : null}
    </div>
  );
}
